import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './asset/userHeaderBar.module.scss';
import PageIntroduction from '../pageIntroduction/pageIntroduction';
import AccountInfoHolder from '../accountInforHolder/accountInfoHolder';
import { refreshUser } from '../../reduxStore/actions/userActionsHelper';
import { usersData$ } from '../../reduxStore/selectors/userSelectors';
import useDemoPracticeLimit, { DEMO_PRACTICE_LIMIT } from '../../utils/useDemoPracticeLimit';

const IS_DEMO = process.env.REACT_APP_ENVCONFIG === 'demo';

const UserHeaderBar = () => {
    const dispatch = useDispatch();
    const userData = useSelector(usersData$);
    const { remainingTrials, maxTrials, hasReachedLimit } = useDemoPracticeLimit();

    // Fetch latest subscription data when component mounts
    useEffect(() => {
        if (userData?.id) {
            dispatch(refreshUser.request(userData.id));
        }
    }, [dispatch, userData?.id]);

    return (
        <div className={styles.introductionParent}>
            <div className={styles.introductionMain}>
                <PageIntroduction />
            </div>

            {IS_DEMO && userData?.isDemo && (
                <div className={`${styles.demoBadge} ${hasReachedLimit ? styles.demoBadgeFull : ''}`}>
                    <span className={styles.demoBadgeIcon}>{hasReachedLimit ? '🔒' : '⚡'}</span>
                    <div className={styles.demoBadgeContent}>
                        <span className={styles.demoBadgeTitle}>
                            {hasReachedLimit ? 'Session limit reached' : 'Demo Mode'}
                        </span>
                        <span className={styles.demoBadgeText}>
                            {hasReachedLimit
                                ? `You've used all ${maxTrials || DEMO_PRACTICE_LIMIT} practice sessions`
                                : `You have ${remainingTrials} of ${maxTrials || DEMO_PRACTICE_LIMIT} practice sessions remaining`}
                        </span>
                    </div>
                </div>
            )}

            <div className={styles.introductionSide}>
                <AccountInfoHolder />
            </div>
        </div>
    );
};

export default UserHeaderBar;
